import React from 'react';
import {r} from "@/utils/responsive";
import k8sKeeperCardBg from "@/assets/img/k8s_keeper_card_bg.png"
import bgCardVideo from "@/assets/video/bg_card_video.mp4"
import k8sAvatar from "@/assets/img/k8s_avatar.png"
import DisabledWrapper from "@/components/DisabledWrapper";
import {S3_FILES} from "@/config/s3_files";
import ReactPlayerWrapper from "@/components/ReactPlayerWrapper";

interface K8SKeeperCardProps extends React.HTMLAttributes<HTMLDivElement> {
}

const K8SKeeperCard: React.FC<K8SKeeperCardProps> = ({className, ...props}) => {
    return (
        <div
            {...props}
            style={{
                position: "relative",
                width: r.vmax(939),
                height: r.vmax(461),
                padding: `${r.vmax(153)} ${r.vmax(72)} 0`,
                color: '#ffffff',
                fontSize: r.vmax(28),
                lineHeight: r.vmax(36),
                whiteSpace: 'pre-wrap',
                marginTop: r.vmax(115),
            }}
        >
            {/* Невидимый SVG с определением clipPath */}
            <svg style={{position: 'absolute', width: 0, height: 0}}>
                <defs>
                    <clipPath id="card_video_mask_keeper" clipPathUnits="objectBoundingBox">
                        <path
                            d="M0 0.266C0 0.184 0 0.143 0.0125 0.118C0.025 0.092 0.045 0.092 0.085 0.092H0.128H0.186H0.786C0.801 0.092 0.808 0.092 0.815 0.087C0.822 0.083 0.828 0.073 0.839 0.054L0.849 0.038C0.86 0.019 0.866 0.01 0.873 0.005C0.88 0 0.887 0 0.902 0H0.914C0.955 0 0.975 0 0.988 0.025C1 0.051 1 0.092 1 0.174V0.794C1 0.859 1 0.89 0.992 0.913C0.989 0.921 0.986 0.928 0.982 0.934C0.97 0.951 0.955 0.951 0.924 0.951C0.917 0.951 0.914 0.951 0.911 0.952C0.91 0.952 0.909 0.952 0.908 0.952C0.904 0.954 0.901 0.956 0.896 0.961L0.866 0.985C0.858 0.991 0.855 0.994 0.851 0.996C0.847 0.998 0.843 0.998 0.834 0.998H0.085C0.045 0.998 0.025 0.998 0.0125 0.972C0 0.947 0 0.906 0 0.824L0 0.266Z"
                        />
                    </clipPath>
                </defs>
            </svg>

            <img style={{
                pointerEvents: 'none',
                position: 'absolute',
                zIndex: 2,
                left: r.vmax(-16),
                top: r.vmax(-95),
                width: r.vmax(276),
                height: r.vmax(284),
            }} alt="" src={S3_FILES.KEEPER_CARD_AVATAR}/>

            <div style={{
                position: 'relative',
                zIndex: 2,
                letterSpacing: r.vmax(-0.20),
                display: 'flex',
                flexDirection: 'column',
                gap: r.vmax(20),
            }}>

                <p>{`K8sKeeper, вы — герой, который попадает в мир \nКонтейнерлэнд, где царит хаос и нарушился \nбаланс из-за ошибок в управлении \nконтейнерами.`}</p>
                <p>{`Ваша задача — восстановить порядок, используя \nсилу Kubernetes®!`}</p>
            </div>

            <DisabledWrapper>
                <img src={S3_FILES.KEEPER_CARD_BG} alt="" style={{
                    position: 'absolute',
                    inset: 0,
                    objectPosition: 'top',
                    objectFit: 'contain',
                    zIndex: 1,
                    opacity: .9
                }}/>

                <div style={{
                    position: 'absolute',
                    inset: 0,
                    clipPath: 'url(#card_video_mask_keeper)',
                }}>
                    <ReactPlayerWrapper videoSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO}
                                        posterSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO_POSTER} style={{
                        clipPath: 'url(#card_video_mask_keeper)',
                    }}/>
                </div>
            </DisabledWrapper>
        </div>
    );
};

export default K8SKeeperCard;
